<template>
    <div>
        <nav class="bg-white border-b z-50 fixed flex items-center justify-between lg:justify-start top-0 left-0 right-0 py-3 lg:py-4 px-4">
            <button class="order-1 lg:order-2 focus:outline-none" @click="open = !open, account = false">
                <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <!-- bar -->
                    <path :class="{ 'hidden': open }" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                    <!-- close -->
                    <path :class="{ 'hidden': !open, 'lg:hidden': open }" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    <!-- chevron -->
                    <path :class="{ 'hidden': !open, 'hidden lg:block': open }" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
            <a class="text-xl lg:w-56 order-2 lg:order-1 font-semibold tracking-widest uppercase" href="index.html">Simplicity</a>
            <!-- Navbar-->
            <button @click="account = !account" class="order-last relative lg:absolute lg:right-5 focus:outline-none">
                <span class="hidden lg:inline-block pr-2 font-semibold text-sm text-gray-600">Muhaecal D. Khatami</span>
                <img src="../assets/profile.jpg" class="w-9 h-9 rounded-full border inline-block">
                <div v-if="account" class="bg-white absolute right-0 border text-left w-52 text-sm rounded-lg transform translate-y-2">
                    <ul>
                        <li class="py-2 px-4 hover:bg-gray-100 bg-gray-100 text-gray-500 font-semibold">Account</li>
                        <li class="py-2 px-4 hover:bg-gray-100">
                            <a href="#" class="flex items-center space-x-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <span>Profile</span>
                            </a>
                        </li>
                        <li class="py-2 px-4 hover:bg-gray-100">
                            <a href="#" class="flex items-center space-x-1">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <span>Setting</span>
                            </a>
                        </li>
                        <li class="py-2 px-4 hover:bg-gray-100 border-t">Logout</li>
                    </ul>
                </div>
            </button>
        </nav>

        <nav :class="{'transform w-0 lg:w-60 lg:px-4': !open, 'transform w-60 px-4 lg:w-20 hover:w-60': open}" class="group bg-gray-800 origin-left duration-300 h-screen fixed top-0 left-0 z-40 pt-20 overflow-x-hidden">
            <div class="uppercase text-gray-400 text-xs pb-3">Menu</div>
            <ul>
                <!-- default menu -->
                <li>
                    <a :class="{ 'w-52': !open, 'w-52 lg:w-auto': open }" class="nav-link text-gray-200 bg-gray-700" href="index.html">
                        <svg class="w-6 h-6 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                        </svg>
                        <span :class="{ 'lg:hidden group-hover:block': open }">Dashboard</span>
                    </a>
                </li>
                <!-- dropdown menu -->
                <li class="dropdown relative">
                    <a :class="{ 'w-52': !open, 'w-52 lg:w-auto': open }" class="nav-link text-gray-200" href="#">
                        <!-- menu icon -->
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                        </svg>
                        <!-- menu title -->
                        <span :class="{ 'lg:hidden group-hover:block': open }">Dropdown</span>
                        <!-- arrow -->
                        <svg :class="{ 'lg:hidden group-hover:block': open }" class="transform duration-300 absolute right-1 w-0.5 h-0.5 arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </a>
                    <ul :class="{ 'lg:hidden group-hover:block': open }" class="dropdown-items">
                        <li>
                            <a href="#">Menu 1</a>
                        </li>
                        <li>
                            <a href="#">Menu 2</a>
                        </li>
                        <li>
                            <a href="#">Menu 3</a>
                        </li>
                    </ul>
                </li>
                <li class="dropdown relative">
                    <a :class="{ 'w-52': !open, 'w-52 lg:w-auto': open }" class="nav-link text-gray-200" href="#">
                        <!-- menu icon -->
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" />
                        </svg>
                        <!-- menu title -->
                        <span :class="{ 'lg:hidden group-hover:block': open }">Component</span>
                        <!-- arrow -->
                        <svg :class="{ 'lg:hidden group-hover:block': open }" class="transform duration-300 absolute right-1 w-0.5 h-0.5 arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </a>
                    <ul :class="{ 'lg:hidden group-hover:block': open }" class="dropdown-items">
                        <li>
                            <a href="#">Component 1</a>
                        </li>
                        <li>
                            <a href="#">Component 2</a>
                        </li>
                        <li>
                            <a href="#">Component 3</a>
                        </li>
                    </ul>
                </li>
                <div class="uppercase text-gray-400 text-xs pt-5 pb-3">Other</div>
                <li>
                    <a :class="{ 'w-52': !open, 'w-52 lg:w-auto': open }" class="nav-link text-gray-200" href="index.html">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <span :class="{ 'lg:hidden group-hover:block': open }">Form</span>
                    </a>
                </li>
                <li>
                    <a :class="{ 'w-52': !open, 'w-52 lg:w-auto': open }" class="nav-link text-gray-200" href="index.html">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                        <span :class="{ 'lg:hidden group-hover:block': open }">Table</span>
                    </a>
                </li>
                <li>
                    <a :class="{ 'w-52': !open, 'w-52 lg:w-auto': open }" class="nav-link text-gray-200" href="index.html">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                        </svg>
                        <span :class="{ 'lg:hidden group-hover:block': open }">Chart</span>
                    </a>
                </li>
            </ul>
        </nav>
        <div @click="open = false" v-if="open" class="bg-gray-400 w-screen md:w-0 fixed h-screen md:h-0 z-30 top-0 bg-opacity-50 transform duration-300"></div>
            
        <div :class="{ 'lg:transform lg:ml-60': !open, 'lg:transform lg:ml-20': open }" class="duration-300 mt-20 px-4 lg:px-8">
            <div class="breadcrumb-list">
                <ul class="flex items-center space-x-2 text-sm">
                    <li class="text-gray-500"><a href="index.html">Home</a></li>
                    <li class="text-gray-500 breadcrumb-item"><a href="#">Admin</a></li>
                    <li class="breadcrumb-item active">Dashboard</li>
                </ul>
            </div>
            <!-- info box with chart -->
            <div class="grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-7 mt-4 mb-7">
                <!-- income -->
                <info-box title="90%" subtitle="Income" color="#3B82F6" :options="incomeOptions">
                    <div class="bg-blue-500 text-blue-500 bg-opacity-10 rounded-full w-10 h-10 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z" />
                        </svg>
                    </div>
                </info-box>
                <!-- orders -->
                <info-box title="2,000" subtitle="Orders" color="#EF4444" :options="orderOptions">
                    <div class="bg-red-500 text-red-500 bg-opacity-10 rounded-full w-10 h-10 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                        </svg>
                    </div>
                </info-box>
                <!-- new user -->
                <info-box title="+300" subtitle="New User" color="#10B981" :options="newUserOptions">
                    <div class="bg-green-500 text-green-500 bg-opacity-10 rounded-full w-10 h-10 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                        </svg>
                    </div>
                </info-box>
                <!-- user -->
                <info-box title="10,000" subtitle="User" color="#F59E0B" :options="userOptions">
                    <div class="bg-yellow-500 text-yellow-500 bg-opacity-10 rounded-full w-10 h-10 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                    </div>
                </info-box>
            </div>
            <!-- area chart -->
            <div class="grid lg:grid-cols-2 gap-7 mb-7">
                <area-chart title="Bar Chart" type="bar" />
                <column-chart />
            </div>
            <div class="bg-white rounded mb-7">
                <!-- table -->
                <div class="flex justify-between items-center p-4">
                    <!-- search -->
                    <div class="flex-1 pr-4">
                        <div class="relative md:w-1/3">
                            <input type="search"
                                class="w-full pl-10 pr-4 py-2 rounded-lg focus:outline-none focus:shadow-outline text-gray-600 font-medium"
                                placeholder="Search...">
                            <div class="absolute top-0 left-0 inline-flex items-center p-2">
                                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-gray-400" viewBox="0 0 24 24"
                                    stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <rect x="0" y="0" width="24" height="24" stroke="none"></rect>
                                    <circle cx="10" cy="10" r="7" />
                                    <line x1="21" y1="21" x2="15" y2="15" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="overflow-auto h-96 lg:h-auto">
                    <table class="table-responsive">
                        <thead>
                            <tr>
                                <th v-for="(heading, index) in headings" :key="index">
                                    {{ heading }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(user, index) in users" :key="index">
                                <td>{{ index+1 }}</td>
                                <td>{{ user.first }}</td>
                                <td>{{ user.last }}</td>
                                <td>{{ user.email }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import InfoBox from './InfoBox.vue' //info box with chart component
import AreaChart from './AreaChart.vue'
import chartOptions from '../data/chartOptions.js'
import ColumnChart from './ColumnChart.vue'

export default {
    components: {
        InfoBox,
        AreaChart,
        ColumnChart,
        // DataTable
    },
    data: function() {
        return {
            open: false,
            account: false,

            //chart options
            incomeOptions: chartOptions.income,
            orderOptions: chartOptions.order,
            newUserOptions: chartOptions.newUser,
            userOptions: chartOptions.user,

            //table
            headings: [
                'User ID',
                'First',
                'Last',
                'Email',
            ],

            users: []

        }
    },
    methods: {
        drop(id) {
            const el = document.getElementById(id)
            el.classList.toggle('hidden')
        },
        fakeUsers() {
            return {
                first: this.$faker().name.firstName(),
                last: this.$faker().name.lastName(),
                email: this.$faker().internet.email()
            }
        }
    },
    mounted() {
        let dropdowns = document.querySelectorAll('.dropdown');
        for(var i = 0; i < dropdowns.length; i++) {
            let dropdownItem = dropdowns[i];
            dropdowns[i].querySelector('.nav-link').addEventListener('click', function() {
                
                let dropdownArrow = dropdownItem.querySelector('.arrow');
                let dropdownMenu = dropdownItem.querySelector('.dropdown-items');

                dropdownArrow.classList.toggle('rotate-90');

                dropdownMenu.classList.toggle('max-h-0');
                dropdownMenu.classList.toggle('max-h-96');
            })
        }
    },
    created() {
        for(var i = 1; i <= 10; i++) {
            this.users.push(this.fakeUsers());
        }
    }
}
</script>

<style>
    .breadcrumb-item::before {
        content: '/';
        display: inline-block;
        padding-right: 10px;
    }
</style>